<style>
.logout_user {
  color: #212529
}

.setting_user.active {
  color: #097E52 !important;
}

/* CSS để căn giữa logo */
.navbar-header {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

#mobile_btn {
  position: absolute;
  left: 0;
}

.navbar-brand.logo {
  margin: 0 auto;
  text-align: center;
}

@media only screen and (max-width: 850px) {
  .navbar-header .navbar-brand img {
    height: 2.308rem !important;
    max-width: 180px;
  }
  
  .navbar-header {
    flex: 1;
  }
  
  .header-nav {
    display: flex !important;
    justify-content: space-between;
  }
}
</style>
<template>
  <header
      :class="{
      'header-trans': logoPath === '/trang-chu',
      'header-sticky fixed-top': logoPath !== '/trang-chu',
      isScrolled,
    }"
      :style="{
      background: isScrolled ? 'rgb(255,255,255)' : 'rgb(186, 42, 51)',
    }"
      class="header">
    <div class="container-fluid">
      <nav class="navbar navbar-expand-lg header-nav">
        <div class="navbar-header">
          <a id="mobile_btn" href="javascript:void(0);" @click="toggleSidebar">
            <span class="bar-icon">
              <span :style="{ backgroundColor: !isScrolled && logoPath === '/trang-chu' ? 'rgb(255,255,255)' : 'rgb(186, 42, 51)' }"></span>
              <span :style="{ backgroundColor: !isScrolled && logoPath === '/trang-chu' ? 'rgb(255,255,255)' : 'rgb(186, 42, 51)' }"></span>
              <span :style="{ backgroundColor: !isScrolled && logoPath === '/trang-chu' ? 'rgb(255,255,255)' : 'rgb(186, 42, 51)' }"></span>
            </span>
          </a>
          <router-link class="navbar-brand logo" to="/trang-chu">
            <img
                :src="require(`@/assets/img/${logoImage}`)"
                alt="Logo"
                class="img-fluid"
                style="height: 60px"
            />
          </router-link>
        </div>
        <div class="main-menu-wrapper">
          <div class="menu-header">
            <router-link class="menu-logo" to="/trang-chu">
              <img
                  alt="Logo"
                  class="img-fluid"
                  src="@/assets/img/logo_red.png"
                  style="height: 60px"
              />
            </router-link>
            <a id="menu_close" class="menu-close" href="javascript:void(0);">
              <i class="fas fa-times"></i
              ></a>
          </div>
          <header-menu></header-menu>
        </div>
        <ul class="nav header-navbar-rht logged-in">
          <!-- Notification Menu -->
          <li class="nav-item">
            <notification-list/>
          </li>
          <!-- /Notification Menu -->

          <!-- User Menu -->
          <li class="nav-item dropdown has-arrow logged-item">
            <a
                class="dropdown-toggle nav-link"
                data-bs-toggle="dropdown"
                href="javascript:void(0);"
            >
              <span class="user-img">
                <img
                    :alt="player?.display_name ?? player?.last_name"
                    :src="imagePlayer"
                    class="rounded-circle"
                    style="width: 40px"
                />
              </span>
            </a>
            <div class="dropdown-menu dropdown-menu-end">
              <div class="user-header">
                <div class="avatar avatar-sm">
                  <img
                      :alt="player?.display_name ?? player?.last_name"
                      :src="imagePlayer"
                      class="avatar-img rounded-circle"
                  />
                </div>
                <div class="user-text">
                  <h6>{{ player?.display_name ?? player?.last_name }}</h6>
                  <router-link
                      class="text-profile mb-0"
                      to="/user/sua-thong-tin"
                  >Thông tin cá nhân
                  </router-link>
                </div>
              </div>
              <p>
                <router-link class="dropdown-item setting_user" to="/user/sua-thong-tin"
                >Cài đặt
                </router-link
                >
              </p>
              <p>
                <!-- <router-link class="dropdown-item">Logout</router-link> -->
                <a class="dropdown-item logout_user" @click="authStore.logout()"
                >Đăng xuất</a
                >
              </p>
            </div>
          </li>
          <!-- /User Menu -->
        </ul>
      </nav>
    </div>
    <div
        class="sidebar-overlay"
        :class="{ opened: isSidebarOpen }"
        @click="closeSidebar"
    ></div>
  </header>
</template>
<script setup>
import {ref, computed, onMounted, onBeforeUnmount, watch} from 'vue';
import {useRoute} from 'vue-router';

import {usePlayerStore} from '@/stores/playerStore';
import {useAuthStore} from '@/stores/auth';
import NotificationList from '@/components/notification/notification-list.vue';
import { isMobile } from '@/helpers/responsive';

const authStore = useAuthStore();
const playerStore = usePlayerStore();

const route = useRoute();

const isScrolled = ref(false)
const isSidebarOpen = ref(false)
const logRegisterClass = ref('')
const url = process.env.VUE_APP_SERVER_URL;

const logoPath = computed(() => route.path);

const logoImage = computed(() => {
  if (logoPath.value === "/trang-chu") {
    return isScrolled.value ? "logo_red.png" : "logo_white.png";
  } else {
    return "logo_red.png";
  }
});

function updateLogRegisterClass(path) {
  if (path === "/trang-chu") {
    logRegisterClass.value = "nav-link btn btn-white log-register";
  } else {
    logRegisterClass.value = "nav-link btn btn-primary log-register";
  }
}

function handleScroll() {
  const scroll = window.scrollY;
  isScrolled.value = scroll > 35;
}

const player = computed(() => playerStore.userData?.player)
const imagePlayer = computed(() => {
  if (player.value?.photo?.url) {
    return url + player.value.photo.url
  } else {
    return '/img/profiles/default_profile.webp'
  }
})

const toggleSidebar = () => {
  isSidebarOpen.value = !isSidebarOpen.value
  document.documentElement.classList.toggle('menu-opened')
}

const closeSidebar = () => {
  isSidebarOpen.value = false
  document.documentElement.classList.remove('menu-opened')
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
  updateLogRegisterClass(route.path);
});

onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll);
});

watch(route, (newRoute) => {
  updateLogRegisterClass(newRoute.path);
});

watch(
    () => route.path,
    (newPath) => {
      updateLogRegisterClass(newPath)
    },
    { immediate: true }
)
</script>
